import { AdsignMap, loadMap } from "@adactiveasia/adsign-map";
import React, { createContext, useEffect, useRef } from "react";
import { mapConfig, mapOption } from "./constants/mapConstant";
import { observer } from "mobx-react-lite";
import { useStores } from "./use.store";

const AdsignMapContext = createContext();

const AdsignMapProvider = observer(({ children }) => {
  const { mapStore } = useStores();

  return (
    <AdsignMapContext.Provider value={mapStore}>
      {children}
    </AdsignMapContext.Provider>
  );
});

export { AdsignMapContext, AdsignMapProvider };
